var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconDislike01 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "square",
  strokeWidth: 1.2,
  d: "m12.588 10.152-2.51 4.013a1.08 1.08 0 0 1-.93.514v0a1.1 1.1 0 0 1-1.137-1.087v-2.877h-4.34A1.137 1.137 0 0 1 2.585 9.41l.791-5.1a1.13 1.13 0 0 1 1.117-.99h6.485c.309 0 .614.07.89.208l.711.356"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.1,
  d: "M12.588 10.152V3.914"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.2,
  d: "M14.932 10.152h-2.343V3.914h2.343a.494.494 0 0 1 .494.494v5.25a.494.494 0 0 1-.494.494"
})));
export default SvgIconDislike01;